module.exports = __webpack_public_path__ + "static/media/registration_bg.254390f5.png";